import { Address4, Address6 } from "ip-address";

export const subnetSize = (cidr: number) => 1 << (32 - cidr);

// inet_aton
export const ipToInt = (ip: string) =>
  ip
    .split(".")
    .map((v) => Number(v))
    .reduce((intv: number, value: number) => intv * 256 + value, 0);

// inet_ntoa

export const intToIp = (v: number) => `${v >>> 24}.${(v >>> 16) & 0xff}.${(v >>> 8) & 0xff}.${v & 0xff}`;

function* subnets(prefix: Address4, newPrefix: number): Generator<Address4> {
  const start = ipToInt(prefix.startAddress().address);
  const end = ipToInt(prefix.endAddress().address);
  const step = subnetSize(newPrefix);
  console.log(`start: ${start}, end: ${end}, step: ${step} would yield ${Math.floor((end - start) / step)} subnets`);
  if ((end - start) / step > 32) {
    return;
  }

  for (let i = start; i < end; i += step) {
    yield new Address4(`${intToIp(i)}/${newPrefix}`);
  }
}

// enumerate all possible subnets inside a prefix.
// for IPv4 only.
export const enumerateSubnetsInPrefix = (prefix: string, size: number) => [...subnets(new Address4(prefix), size)];

export const normalizePrefix = (prefix: string | undefined): number =>
  Number(
    (prefix ?? "")
      .replace(":", ".")
      .replace("/", ".")
      .split(".")
      .map((n) => n.padStart(3, "0"))
      .join("")
      .replace(/\D/g, ""),
  );

export const ipIsInSubnet = (ip: string, subnet: string, v4 = true) => {
  try {
    const addr = v4 ? new Address4(ip) : new Address6(ip);
    const subnetAddr = v4 ? new Address4(subnet) : new Address6(subnet);
    return addr.isInSubnet(subnetAddr);
  } catch (_e) {
    // throws an AddressError on failure
    return false;
  }
};
